import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@providers/useAPI';
import { superEnhancementKeys } from 'app/queries/superEnhancement/superEnhancementKeys';
import { createFetchSuperEnhancementAvailabilityQueryFn } from 'app/queries/superEnhancement/createFetchSuperEnhancementAvailabilityQueryFn';
import { useNavigate } from 'react-router-dom';
import MagicWand from '@components/icons/MagicWand.svg';
import { routes } from '@routes';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { MenuItemButton } from '../MoreActionsMenu/components/MenuItemButton';

export const SuperEnhancementButton = () => {
  const { job } = usePageContext();
  const navigate = useNavigate();
  const { call } = useAPI();
  const availabilityQuery = useQuery({
    queryKey: superEnhancementKeys.availability(job?.id ?? ''),
    queryFn: createFetchSuperEnhancementAvailabilityQueryFn(call),
    enabled: Boolean(job?.id),
    refetchInterval: (query) => {
      if (query.state.status === 'error' || query.state.data?.result === true) {
        return false;
      }
      return 10000;
    },
  });
  const isAvailable = availabilityQuery.data?.result === true && !availabilityQuery.isError;
  const title = availabilityQuery.isError
    ? 'Unable to check Super Enhancement availability'
    : isAvailable
      ? 'Open Super Enhancement'
      : 'The main transcript is not available yet';
  return (
    <MenuItemButton
      disabled={!isAvailable}
      title={title}
      className={isAvailable ? undefined : 'cursor-not-allowed opacity-60'}
      onClick={() => job && navigate(routes.adminJobSuperEnhancement.make(job.id))}
    >
      <MagicWand />
      Super Enhancement
    </MenuItemButton>
  );
};
